import { AxiosInstance } from 'axios';
import RegionService from './regionService';

export default function useRegion( axiosIns: AxiosInstance, regionOverrideConfig: Object ) {
  const region = new RegionService( axiosIns, regionOverrideConfig );

  return {
    region,
  }
}